export default class AccountType {
  static readonly indivisual: string = '1'
  static readonly salon: string = '2'
}
